/**
 * Leave this chat? (07 Workshop, Leaving and losing access). Someone else's
 * shared chat asks before it leaves your chats; the leave itself is then held
 * five seconds with an Undo by the caller.
 */
import type { WorkshopSession } from "@/types/workshop.type";
import WorkshopDialog from "./WorkshopDialog";

type Props = {
  /** The chat being left; null keeps the dialog closed. */
  session: WorkshopSession | null;
  onCancel: () => void;
  onLeave: (session: WorkshopSession) => void;
};

export default function LeaveChatDialog({ session, onCancel, onLeave }: Props) {
  const title = session?.title.trim() || "New chat";
  const owner = session?.owner?.name?.trim() || "its owner";
  return (
    <WorkshopDialog
      isOpen={session !== null}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
      title="Leave this chat?"
      description={`“${title}” leaves your chats. The others keep it, and ${owner} can add you back.`}
      cancelLabel="Cancel"
      confirmLabel="Leave chat"
      confirmTone="danger"
      onConfirm={() => {
        if (session) onLeave(session);
      }}
    />
  );
}
